import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'newComponents'
import { track } from '../../../utils/thirdPartyUtils'

const DemoCTA = ({ to, text, primaryCta, outlineCta, eventName }) => {
  const isButton = primaryCta || outlineCta
  const containerClassName = isButton ? '' : 'homepage-demo-cta'

  const className = classNames('', {
    'button is-large': primaryCta || outlineCta,
    'is-primary modal-trigger border-radius-2': primaryCta,
    'is-outline': outlineCta,
    cta: !isButton
  })

  const handleDemoLinkClick = () => {
    track(eventName)
  }

  return (
    <div className={containerClassName}>
      <Link to={to} onClick={eventName ? handleDemoLinkClick : () => {}} className={className}>
        {text}
        {!isButton && <CtaArrow />}
      </Link>
    </div>
  )
}

const CtaArrow = () => (
  <span className="cta-arrow">
    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
      <path d="M85 277.375h259.704L225.002 397.077 256 427l171-171L256 85l-29.922 29.924 118.626 119.701H85v42.75z" />
    </svg>
  </span>
)

DemoCTA.defaultProps = {
  to: '/request-a-demo/',
  text: 'Get a Demo',
  eventName: 'Request Demo Button Clicked'
}

DemoCTA.propTypes = {
  to: PropTypes.string,
  text: PropTypes.string,
  eventName: PropTypes.string
}

export default DemoCTA
